var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoadingRing = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "results-loading_Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 81.6 82.9",
    style: {
      enableBackground: "new 0 0 81.6 82.9"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .results-loading_st0{fill:url(#results-loading_SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "results-loading_SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.8542,
    y1: 18.02,
    x2: 68.7359,
    y2: 64.9103
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3CFDB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5016,
    style: {
      stopColor: "#0F53FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF0983"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "results-loading_st0",
    d: "M40.8,78C20.7,78,4.3,61.6,4.3,41.5S20.7,5,40.8,5s36.5,16.4,36.5,36.5S60.9,78,40.8,78z M40.8,13.1   c-15.6,0-28.3,12.7-28.3,28.3s12.7,28.3,28.3,28.3s28.3-12.7,28.3-28.3S56.4,13.1,40.8,13.1z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoadingRing);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loading_ring.9c6be7a9a14a60abf56ae53c09b98259.svg";